import FormActionButtons from 'components/ui/form-action-buttons';
import type React from 'react';
import { useTranslation } from 'react-i18next';
import { BinderDeploymentProps } from './types';
import SubmissionCurrencyTabProps from '../submission-currency-tabs';
import { useState } from 'react';
import { DEFAULT_CONVERSION_CURRENCY } from '../submission-details/types';
import BinderDeploymentTable from './components/binder-deployment-table';
import TotalDeploymentPerBinderTable from './components/total-deployment-per-binder';

const BinderDeployment: React.FC<BinderDeploymentProps> = ({
  submission,
  includeBack,
  includeNext,
  navigateBack,
  navigateNext,
}) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(
    submission.originalCurrency || DEFAULT_CONVERSION_CURRENCY
  );
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [isTotalDeploymentPerBinderError, setIsTotalDeploymentPerBinderError] =
    useState(true);
  return (
    <div className="rounded-lg bg-[#E3F2FB]">
      <div className="flex items-center justify-between">
        <SubmissionCurrencyTabProps
          originalCurrency={submission.originalCurrency}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        />
      </div>
      <div className="flex flex-col gap-5 mb-4">
        <BinderDeploymentTable
          submission={submission}
          onErrorChange={setIsNextDisabled}
          currency={activeTab}
          originalCurrency={submission.originalCurrency}
        />
        <TotalDeploymentPerBinderTable
          submissionId={submission.submissionId}
          onErrorChange={setIsTotalDeploymentPerBinderError}
        />
      </div>

      <FormActionButtons
        confirmText={t('general.next')}
        cancelText={t('general.back')}
        isConfirmDisabled={isNextDisabled || isTotalDeploymentPerBinderError}
        includeCancel={includeBack}
        includeConfirm={includeNext}
        confirmOutlined={false}
        onCancel={navigateBack}
        onConfirm={navigateNext}
      />
    </div>
  );
};

export default BinderDeployment;
